<template>
  <div class="goods-list">
    <el-card shadow="never">
      <div class="content">
        <div class="content-header">
          <el-form :inline="true" ref="vSearchForm" :model="query" label-width="130px">
            <el-form-item label="收款主体公司编码" prop="code">
              <el-select v-model="query.code" placeholder="请选择">
                <el-option value label="全部" />
                <el-option
                  v-for="item in searchSelectOptions"
                  :key="item.id"
                  :label="item.code"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="收款主体公司名称" prop="comapny">
              <el-select v-model="query.company" placeholder="收款主体公司名称">
                <el-option value label="全部" />
                <el-option
                  v-for="item in searchSelectOptions"
                  :key="item.id"
                  :label="item.company"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="收款主体状态" prop="collectionStatus">
              <el-select v-model="query.collectionStatus" placeholder="请选择">
                <el-option value label="全部" />
                <el-option value="1" label="启用" />
                <el-option value="0" label="停用" />
              </el-select>
            </el-form-item>
            <el-form-item label="支付产品" prop="payPro" v-if="activeName=='second'">
              <el-select v-model="query.payPro" placeholder="请选择">
                <el-option value label="全部" />
                <el-option value="alipay" label="支付宝应用" />
                <el-option value="native" label="微信native支付" />
                <el-option value="jsapi" label="微信jsapi支付" />
              </el-select>
            </el-form-item>
            <el-form-item label="支付产品状态" prop="payStatus" v-if="activeName=='second'">
              <el-select v-model="query.payStatus" placeholder="支付产品状态">
                <el-option value label="全部" />
                <el-option value="1" label="启用" />
                <el-option value="0" label="停用" />
              </el-select>
            </el-form-item>

            <el-form-item label="创建时间" prop="createDate">
              <el-date-picker
                v-model="query.createDate"
                type="daterange"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :shortcuts="shortcuts"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">搜索</el-button>
              <el-button type="danger" @click="resetSearchForm">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="content-main">
          <el-tabs v-model="activeName" @tab-click="tabsHandleClick" >
            <el-tab-pane label="收款主体" name="first">
              <template #label>
                <span>收款主体</span>
              </template>
              <div class="table">
                <el-button
                  type="primary"
                  @click="openDialog"
                  style="float:right;margin-bottom: 10px;"
                  v-if="this.$permission.check('收款主体&产品','收款主体新增')"
                >新增</el-button>
                <el-table
                  :data="tableData"
                  border
                  stripe
                   v-loading = "collectionLoading"
                  style="width: 100%; "
                
                >
                  <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
                  <el-table-column prop="code" label="收款主体公司编码" align="center"></el-table-column>
                  <el-table-column prop="company" label="收款主体公司名称" align="center"></el-table-column>
                  <el-table-column prop="format_create_time" label="创建时间" align="center"></el-table-column>
                  <el-table-column prop="wechatproducts" label="微信收款产品" align="center"></el-table-column>
                  <el-table-column prop="alipayproducts" label="支付宝收款产品" align="center"></el-table-column>
                  <el-table-column prop="status_text" label="收款主体状态" align="center"></el-table-column>
                  <el-table-column label="操作" align="center" width="210">
                    <template #default="scope">
                      <el-button type="primary" size="small" @click="editDialog(scope.row)" v-if="this.$permission.check('收款主体&产品','收款主体编辑')">编辑</el-button>
                      <el-button
                        v-if="scope.row.status && this.$permission.check('收款主体&产品','收款主体停用')"
                        type="danger"
                        size="small"
                        @click="disableButton(scope.row)"
                      >停用</el-button>
                      <el-button
                        v-if="!scope.row.status && this.$permission.check('收款主体&产品','收款主体启用')"
                        type="success"
                        size="small"
                        @click="enableButton(scope.row)"
                      >启用</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  background
                  layout="total, prev, pager, next"
                  :current-page="query.pageIndex"
                  :page-size="query.pageSize"
                  :total="pageTotal"
                  @current-change="handlePageChange"
                ></el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane label="支付产品" name="second">
              <template #label>
                <span>支付产品</span>
              </template>
              <el-button
                type="primary"
                @click="openProDialog"
                style="float:right;margin-bottom: 10px;"
              >新增</el-button>

              <el-table
                :data="tableProData"
                border
                stripe
                style="width: 100%; "
                v-loading = "proLoading"
              >
                <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
                <el-table-column prop="code" label="收款主体公司编码" align="center"></el-table-column>
                <el-table-column prop="company" label="收款主体公司名称" align="center"></el-table-column>
                <el-table-column prop="paytype" label="支付产品" align="center" width="100"></el-table-column>
                <el-table-column prop="format_create_time" label="创建时间" align="center"></el-table-column>
                <el-table-column prop="status_text" label="状态" align="center" width="100"></el-table-column>
                <el-table-column label="操作" align="left" width="240">
                  <template #default="scope">
                    <el-button type="primary" size="small" @click="editProDialog(scope.row)" v-if="this.$permission.check('收款主体&产品','支付产品编辑')">编辑</el-button>
                    <el-button
                      v-if="scope.row.paystatus && this.$permission.check('收款主体&产品','支付产品停用')"
                      type="danger"
                      size="small"
                      @click="disableButtonPro(scope.row)"
                    >停用</el-button>
                    <el-button
                      v-if="!scope.row.paystatus && this.$permission.check('收款主体&产品','支付产品启用')"
                      type="success"
                      size="small"
                      @click="enableButtonPro(scope.row)"
                    >启用</el-button>

                    <el-popover
    placement="top-start"
    title=""
    :width="350"
    trigger="click"
    v-if="scope.row.paytype=='alipay'"
  >
  <div>
    <el-form :inline="true">
       <el-form-item>
    <el-input ref="demoInput" :value="scope.row.cAddress" readonly size="mini" style="width:270px;">{{scope.row.cAddress}}</el-input>
       </el-form-item>
        <el-form-item>
    <el-button type="primary" size="mini" @click="copyText()" icon="el-icon-document-copy"></el-button>
        </el-form-item>
    </el-form>
    </div>
    <template #reference >
      <el-button type="primary" size="small" v-if="scope.row.paytype=='alipay'" >回调地址</el-button>
    </template>
     </el-popover>
                  </template>
                  
                </el-table-column>
              </el-table>
              <el-pagination
                background
                layout="total, prev, pager, next"
                :current-page="queryPro.pageIndex"
                :page-size="queryPro.pageSize"
                :total="pageTotalPro"
                @current-change="handlePageProChange"
              ></el-pagination>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </el-card>

    <el-dialog :title="dialogTitle" v-model="dialogFormVisible" width="30%" >
      <el-form :model="form" label-width="150px" :rules="rules" ref="formRef" status-icon>
        <el-form-item label="收款主体公司编码" prop="code">
          <el-input v-model="form.code"></el-input>
        </el-form-item>
        <el-form-item label="收款主体公司名称" prop="company">
          <el-input v-model="form.company"></el-input>
        </el-form-item>
        <el-form-item prop="id" hidden>
          <el-input v-model="form.id"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="resetForm('formRef')">取 消</el-button>
          <el-button type="primary" @click="submitForm('formRef')">确 定</el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog :title="dialogTitlePro" v-model="dialogFormVisiblePro" width="40%" >
      <el-form :model="formPro" label-width="150px" :rules="rulesPro" ref="formRefPro" status-icon>
        <el-form-item label="收款主体公司名称" prop="colid">
          <el-select v-model="formPro.colid" placeholder="请选择" :disabled="colidDisabled">
            <el-option
              v-for="item in formPro.alioptions"
              :key="item.id"
              :label="item.company"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付方式">
          <el-radio-group v-model="formPro.paytype" @change="paytypeChange"  :disabled="paytypeDisabled">
            <el-radio label="native">微信Native支付</el-radio>
            <el-radio label="jsapi">微信JSAPI支付</el-radio>
            <el-radio label="alipay">支付宝应用</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="formPro.paytype!='alipay'">
          <el-form-item label="服务商模式">
            <el-radio-group v-model="formPro.serviceType" @change="paytypeChange">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="APP_ID" prop="sp_app_id" v-if="formPro.serviceType=='是'">
            <el-input v-model="formPro.sp_app_id"></el-input>
          </el-form-item>
          <el-form-item label="SUB_APP_ID" prop="sub_app_id">
            <el-input v-model="formPro.sub_app_id"></el-input>
          </el-form-item>
          <el-form-item label="MCH_ID" prop="sp_mch_id" v-if="formPro.serviceType=='是'">
            <el-input v-model="formPro.sp_mch_id"></el-input>
          </el-form-item>
          <el-form-item label="SUB_MCH_ID" prop="sub_mch_id">
            <el-input v-model="formPro.sub_mch_id"></el-input>
          </el-form-item>
          <el-form-item label="证书序列号" prop="serial_no">
            <el-input v-model="formPro.serial_no"></el-input>
          </el-form-item>
          <el-form-item label="API-V3-KEY" prop="api_v3_key" >
            <el-input v-model="formPro.api_v3_key"></el-input>
          </el-form-item>
          <el-form-item label="证书路径" prop="merchant_key" >
            <el-input v-model="formPro.merchant_key"></el-input>
          </el-form-item>
          <!-- <el-form-item label="APP_SECRET" prop="appsecret" v-if="formPro.paytype=='native'">
            <el-input v-model="formPro.appsecret"></el-input>
          </el-form-item>
          <el-form-item label="KEY" prop="key" v-if="formPro.paytype=='native'">
            <el-input v-model="formPro.key"></el-input>
          </el-form-item> -->
        </div>
        <div v-if="formPro.paytype=='alipay'">
          <el-form-item label="应用APP_ID" prop="app_id">
            <el-input v-model="formPro.app_id"></el-input>
          </el-form-item>
          <el-form-item label="证书类型">
            <el-radio-group v-model="formPro.aliPemType">
              <el-radio label="RSA2"></el-radio>
              <el-radio label="RSA"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="秘钥格式">
            <el-radio-group v-model="formPro.aliKeyType">
              <el-radio label="1">PKCS8(JAVA适用)</el-radio>
              <el-radio label="0">PKCS1(非JAVA适用)</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="应用公钥" prop="aliPublicKey">
            <el-input v-model="formPro.aliPublicKey"></el-input>
          </el-form-item>
          <el-form-item label="应用私钥" prop="aliPrivateKey">
            <el-input v-model="formPro.aliPrivateKey"></el-input>
          </el-form-item>
          <el-form-item label="支付宝公钥" prop="aliCommonPublicKey">
            <el-input v-model="formPro.aliCommonPublicKey"></el-input>
          </el-form-item>
        </div>
        <el-form-item prop="id" hidden>
          <el-input v-model="formPro.id"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="resetProForm('formRefPro')">取 消</el-button>
          <el-button type="primary" @click="submitProForm('formRefPro')">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessageBox, ElNotification } from "element-plus";
import {
  listCollection,
  enableDisableCollection,
  saveCollection,
  saveProduct,
  selectCollection,
  listProduct,
  getProduct,
  enableDisableProduct
} from "../api/serviceApi";
import { formatTime } from "../utils/formatTime";
export default {
  data() {
    return {
      query: {
        company: "",
        code: "",
        collectionStatus: "",
        payPro: "",
        payStatus: "",
        createDate: "",
        pageIndex: 1,
        pageSize: 10
      },
      searchSelectOptions: "",
      queryPro: {
        company: "",
        code: "",
        pageIndex: 1,
        pageSize: 10
      },
      starttime: "",
      endtime: "",
      tableData: [],
      tableProData: [],
      delList: [],
      editVisible: false,
      pageTotal: 0,
      pageTotalPro: 0,
      form: {
        code: "",
        company: "",
        id: 0
      },
      formPro: {
        paytype: "native",
        aliPemType: "RSA2",
        aliKeyType: "1",
        serviceType: "是",
        serial_no:"",
        api_v3_key:"",
        id: 0
      },
      idx: -1,
      id: -1,
      proLoading:false,
      shortcuts: [
        {
          text: "最近一周",
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            return [start, end];
          })()
        },
        {
          text: "最近一个月",
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            return [start, end];
          })()
        },
        {
          text: "最近三个月",
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            return [start, end];
          })()
        }
      ],
      rules: {
        code: [
          {
            required: true,
            message: "请输入收款主体公司编码",
            trigger: "blur"
          },
          { min: 3, max: 50, message: "长度在 3 到 50 个字符", trigger: "blur" }
        ],
        company: [
          {
            required: true,
            message: "请输入收款主体公司名称",
            trigger: "blur"
          },
          { min: 3, max: 50, message: "长度在 3 到 50 个字符", trigger: "blur" }
        ]
      },
      rulesPro: {
        //wx支付
        sp_app_id: [
          {
            required: true,
            message: "请输入APP_ID",
            trigger: "blur"
          },
          { min: 3, max: 50, message: "长度在 3 到 50 个字符", trigger: "blur" }
        ],
        sub_app_id: [
          {
            required: true,
            message: "请输入SUB_APP_ID",
            trigger: "blur"
          },
          { min: 3, max: 50, message: "长度在 3 到 50 个字符", trigger: "blur" }
        ],
        sp_mch_id: [
          {
            required: true,
            message: "请输入MCH_ID",
            trigger: "blur"
          },
          { min: 3, max: 50, message: "长度在 3 到 50 个字符", trigger: "blur" }
        ],
        sub_mch_id: [
          {
            required: true,
            message: "请输入SUB_MCH_ID",
            trigger: "blur"
          },
          { min: 3, max: 50, message: "长度在 3 到 50 个字符", trigger: "blur" }
        ],
         merchant_key: [
          {
            required: true,
            message: "请输入merchant_key",
            trigger: "blur"
          },
          { min: 3, max: 500, message: "长度在 3 到 500 个字符", trigger: "blur" }
        ],
        // appsecret: [
        //   {
        //     required: true,
        //     message: "请输入APP_SECRET",
        //     trigger: "blur"
        //   },
        //   { min: 3, max: 50, message: "长度在 3 到 50 个字符", trigger: "blur" }
        // ],
        // key: [
        //   {
        //     required: true,
        //     message: "请输入KEY",
        //     trigger: "blur"
        //   },
        //   { min: 3, max: 50, message: "长度在 3 到 50 个字符", trigger: "blur" }
        // ],
        serial_no: [
          {
            required: true,
            message: "请输入证书序列号",
            trigger: "blur"
          },
          { min: 3, max: 50, message: "长度在 3 到 50 个字符", trigger: "blur" }
        ],
        api_v3_key: [
          {
            required: true,
            message: "请输入API-V3-KEY",
            trigger: "blur"
          },
          { min: 3, max: 50, message: "长度在 3 到 50 个字符", trigger: "blur" }
        ],
        //支付宝支付
        colid: [
          {
            required: true,
            message: "请选择收款主体公司名称",
            trigger: "blur"
          }
        ],
        app_id: [
          {
            required: true,
            message: "请输入APP_ID",
            trigger: "blur"
          },
          { min: 3, max: 50, message: "长度在 3 到 50 个字符", trigger: "blur" }
        ],
        aliPublicKey: [
          {
            required: true,
            message: "请输入应用公钥",
            trigger: "blur"
          },
          {
            min: 3,
            max: 500,
            message: "长度在 3 到 500 个字符",
            trigger: "blur"
          }
        ],
        aliPrivateKey: [
          {
            required: true,
            message: "请输入应用私钥",
            trigger: "blur"
          },
          {
            min: 3,
            max: 2000,
            message: "长度在 3 到 2000 个字符",
            trigger: "blur"
          }
        ],
        aliCommonPublicKey: [
          {
            required: true,
            message: "请输入支付宝公钥",
            trigger: "blur"
          },
          {
            min: 3,
            max: 500,
            message: "长度在 3 到 500 个字符",
            trigger: "blur"
          }
        ]
      },
      activeName: "first",
      dialogTitle: "",
      dialogFormVisible: false,
      dialogTitlePro: "",
      dialogFormVisiblePro: false
    };
  },
  created() {
    this.getData();
    this.getSelectCollectionData();
  },
  methods: {
    copyText(){
     this.$refs.demoInput.select()
    document.execCommand('copy')
    },
    searchButton() {
      if (this.query.createDate) {
        this.starttime = formatTime(this.query.createDate[0], "yyyy-MM-dd");
        this.endtime = formatTime(this.query.createDate[1], "yyyy-MM-dd");
      } else {
        this.starttime = "";
        this.endtime = "";
      }

      if (this.activeName == "first") {
        this.getData();
      } else if (this.activeName == "second") {
        this.getProductData();
      }
    },
    resetSearchForm() {
      this.query.createDate = "";
      this.starttime = "";
      this.endtime = "";
      this.$refs["vSearchForm"].resetFields();
      if (this.activeName == "first") {
        this.getData();
      } else if (this.activeName == "second") {
        this.getProductData();
      }
    },
    //单选移除验证效果
    paytypeChange() {
      this.$refs["formRefPro"].clearValidate();
    },
    tabsHandleClick() {
      this.query.createDate = "";
      this.starttime = "";
      this.endtime = "";
      this.$refs["vSearchForm"].resetFields();
      this.getProductData();
    },
    openDialog() {
      this.dialogTitle = "新增收款主体";
      this.dialogFormVisible = true;
    },
    openProDialog() {
      this.dialogTitlePro = "新增支付产品";
      this.colidDisabled=false
      this.paytypeDisabled=false
      this.dialogFormVisiblePro = true;
      // this.formPro={
      //   paytype: "native",
      //   aliPemType: "RSA2",
      //   aliKeyType: '1',
      //   serviceType: "是",
      //   id: 0,
      // };
      this.$refs["formRefPro"].resetFields();
    },
    editDialog(params) {
      this.dialogTitle = "编辑收款主体";
      this.form.id = params.id;
      this.form.code = params.code;
      this.form.company = params.company;
      this.dialogFormVisible = true;
    },
    editProDialog(params) {
      this.colidDisabled=true
      this.paytypeDisabled=true
      getProduct(params).then(res => {
        let data = res.data;
        console.log(data);
        let f = this.formPro;
        if (res.code == 200) {
          if (data.paytype == "alipay") {
            f.aliPrivateKey = data.private_key;
            f.aliCommonPublicKey = data.public_key;
            f.aliPublicKey = data.yy_public_key;
            f.aliPemType = data.sign_type;
            f.id = data.id;
            f.paytype = data.paytype;
            f.app_id = data.app_id;
            f.colid = data.colid;
            data.is_pkcs_8 ? (f.aliKeyType = "1") : (f.aliKeyType = "0");
          } else {
            f.id = data.id;
            f.sp_app_id = data.sp_app_id;
            f.sp_mch_id = data.sp_mch_id;
            f.sub_mch_id = data.sub_mch_id;
            f.sub_app_id = data.sub_app_id;
            f.serial_no = data.serial_no;
            f.api_v3_key = data.api_v3_key;
            f.paytype = data.paytype;
            f.colid = data.colid;
            f.merchant_key=data.merchant_key;
            if (data.sp_app_id && data.sp_mch_id) {
              f.serviceType = "是";
            } else {
              f.serviceType = "否";
            }
          }
        }
      });

      this.dialogTitlePro = "编辑支付产品";
      // this.formPro.id = params.id;
      // this.form.code = params.code;
      // this.form.company = params.company;
      this.dialogFormVisiblePro = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          saveCollection(this.form)
            .then(res => {
              if (res.code == 200) {
                ElNotification({
                  title: "成功",
                  message: "保存成功！",
                  duration: 2000,
                  type: "success"
                });
                this.getData();
                this.dialogFormVisible = false;
              }
            })
            .catch(e => {
              ElMessageBox.alert(e);
              return false;
            });
        } else {
          console.log("error");
          return false;
        }
      });
    },
    submitProForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = this.formPro;
          if (this.formPro.paytype == "alipay") {
            data.private_key = this.formPro.aliPrivateKey;
            data.public_key = this.formPro.aliCommonPublicKey;
            data.yy_public_key = this.formPro.aliPublicKey;
            data.sign_type = this.formPro.aliPemType;
            data.is_pkcs_8 = this.formPro.aliKeyType;
            data.is_prod = 1;
          }else{
            if( this.formPro.serviceType=="是"){
              data.issp=1
            }else{
              data.issp=0
            }
          }
          console.log(data)
          saveProduct(data)
            .then(res => {
              if (res.code == 200) {
                ElNotification({
                  title: "成功",
                  message: "保存成功！",
                  duration: 2000,
                  type: "success"
                });
                this.getProductData();
                this.dialogFormVisiblePro = false;
              }
            })
            .catch(e => {
              ElMessageBox.alert(e);
              return false;
            });
        } else {
          console.log("error");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.dialogFormVisible = false;
      this.$refs[formName].resetFields();
    },
    resetProForm(formName) {
      this.dialogFormVisiblePro = false;
      this.$refs[formName].resetFields();
    },
    getData() {
      this.collectionLoading=true
      let params =
        "?page=" +
        this.query.pageIndex +
        "&code=" +
        this.query.code +
        "&company=" +
        this.query.company +
        "&status=" +
        this.query.collectionStatus +
        "&starttime=" +
        this.starttime +
        "&endtime=" +
        this.endtime;
      listCollection(params).then(res => {
        if (res.code == 200) {
          if (res.data.list) {
            res.data.list.forEach(function(item) {
              if (item.status == 1) {
                item.status_text = "启用";
              } else {
                item.status_text = "停用";
              }
            });
            this.tableData = res.data.list;
            this.pageTotal = res.data.total;
            this.query.pageSize = res.data.size;
            this.query.pageIndex = res.data.page;
          } else {
            this.tableData = [];
            this.pageTotal = 0;
            // this.query.pageSize = res.data.size;
            this.query.pageIndex = 1;
          }
          this.collectionLoading=false
        }
      });
    },
    getProductData() {
      this.proLoading=true
      //除page外，其他使用query查询参数
      let params =
        "?page=" +
        this.queryPro.pageIndex +
        "&code=" +
        this.query.code +
        "&company=" +
        this.query.company +
        "&paystatus=" +
        this.query.payStatus +
        "&status=" +
        this.query.collectionStatus +
        "&paytype=" +
        this.query.payPro +
        "&starttime=" +
        this.starttime +
        "&endtime=" +
        this.endtime;
      listProduct(params).then(res => {
        res.data.list.forEach(function(item) {
          if (item.paystatus == 1) {
            item.status_text = "启用";
          } else {
            item.status_text = "停用";
          }
          item.cAddress="https://casher.iprun.com/api/alipay/oauth/"+item.productid
          console.log(item)
        });
        this.tableProData = res.data.list;
        this.pageTotalPro = res.data.total;
        this.queryPro.pageSize = res.data.size;
        this.queryPro.pageIndex = res.data.page;
        this.proLoading=false
      });
    },
    handlePageChange(val) {
      this.query.pageIndex = val;
      this.getData();
    },
    handlePageProChange(val) {
      this.queryPro.pageIndex = val;
      this.getProductData();
    },
    getSelectCollectionData() {
      selectCollection().then(res => {
        if (res.code == 200) {
          this.formPro.alioptions = res.data;
          this.searchSelectOptions = res.data;
        }else{
          console.log(res)
        }
      });
    },
    enableButton(val) {
      ElMessageBox.confirm(
        "启用此收款主体，与其关联的签约主体可以继续收款，是否继续操作？",
        "提示",
        {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
          callback: action => {
            if ("confirm" == action) {
              enableDisableCollection(val).then(res => {
                if (res.code == 200) {
                  ElNotification({
                    title: "成功",
                    message: "启用成功！",
                    duration: 2000,
                    type: "success"
                  });
                  this.getData();
                }
              });
            }
          }
        }
      );
    },
    enableButtonPro(val) {
      ElMessageBox.confirm(
        "启用此支付产品，与其相关的收款账户将恢复收款功能，是否继续操作？",
        "提示",
        {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
          callback: action => {
            if ("confirm" == action) {
              enableDisableProduct(val).then(res => {
                if (res.code == 200) {
                  ElNotification({
                    title: "成功",
                    message: "启用成功！",
                    duration: 2000,
                    type: "success"
                  });
                  this.getProductData();
                }
              });
            }
          }
        }
      );
    },
    disableButtonPro(val) {
      ElMessageBox.confirm(
        "停用此支付产品，与其相关的收款账户将无法继续收款，是否继续操作？",
        "提示",
        {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
          callback: action => {
            if ("confirm" == action) {
              enableDisableProduct(val).then(res => {
                if (res.code == 200) {
                  ElNotification({
                    title: "成功",
                    message: "停用成功！",
                    duration: 2000,
                    type: "success"
                  });
                  this.getProductData();
                }
              });
            }
          }
        }
      );
    },
    disableButton(val) {
      ElMessageBox.confirm(
        "停用此收款主体，与其关联的签约主体将无法收款，是否继续操作？",
        "提示",
        {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
          callback: action => {
            if ("confirm" == action) {
              enableDisableCollection(val).then(res => {
                if (res.code == 200) {
                  ElNotification({
                    title: "成功",
                    message: "停用成功！",
                    duration: 2000,
                    type: "success"
                  });
                  this.getData();
                }
              });
            }
          }
        }
      );
    }
  }
};
</script>
